import React, { useEffect, useRef, useState } from 'react';
import '@/pages/intelligence/assets/scss/BusinessReports/index.scss';
import ReportSourceLabel from '@/pages/intelligence/components/ReportSourceLabel';
import ReportCard from '@/pages/intelligence/components/ReportCard';
import '@/pages/intelligence/components/LazyReport/index.scss';
import { useIntl, history } from 'umi';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import moment from 'moment';
import Loading from '@/pages/intelligence/components/Loading';
import { debounce } from 'lodash-es';
import { fetchReportExcel } from '@intelligence/services/common';

import DataBrain from '@/pages/home/assets/svg/dataSource/databarin.svg';

import { Layout, Justify, SearchBox, Icon, Segment } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import useData from './_hooks';
import './index.scss';
import { languageItem } from '../../../MobileDevice/Reports/_utils';
import Data from '@op/pages/dataMap/components/data';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
import { resolveReportConfig } from '@intelligence/utils/reportConfig';
const { Content } = Layout;

const databrainIcon = <img src={DataBrain} className="dbi-source-label-new-icon" />;

const NEW_MARK_IDS_MAPPING_KEY = 'ReportsMarketReports';
const tabs = [
  {
    id: 'Newzoo',
    name: 'newzoo',
    pagePoint: 'MarketReports',
    // label: <ReportSourceLabel sourceName="Newzoo" />,
    label: (
      <ReportSourceLabel
        // sourceName="Newzoo"
        needCustomName
        customName="DataBrain"
        needCustomIcon
        customIcon={databrainIcon}
      />
    ),
  },
  {
    id: 'Sensor Tower',
    name: 'sensortower',
    pagePoint: 'MarketReportsSensortower',
    label: <ReportSourceLabel sourceName="Sensor Tower" />,
  },
  {
    id: 'AppMagic',
    name: 'appmagic',
    pagePoint: 'MarketReportsAppMagic',
    label: <ReportSourceLabel sourceName="AppMagic" />,
  },
  {
    id: 'Ampere',
    name: 'Ampere',
    pagePoint: 'MarketReportsOtherVendors',
    label: <ReportSourceLabel sourceName="Ampere" />,
  },
  {
    id: 'VGI',
    name: 'VGI',
    pagePoint: 'MarketReportsVGI',
    label: <ReportSourceLabel sourceName="VGI" />,
  },
  {
    id: 'Stream Hatchet',
    name: 'streamhatchet',
    pagePoint: 'MarketReportsStreamHatchet',
    label: <ReportSourceLabel sourceName="Stream Hatchet" />,
  },
  // {
  //   id: 'Fandom',
  //   name: 'fandom',
  //   pagePoint: 'MarketReportsFandom',
  //   label: <ReportSourceLabel sourceName="Fandom" />,
  // },
  {
    id: 'Others',
    name: 'others',
    value: 'others',
    pagePoint: 'MarketReportsOthers',
    label: <ReportSourceLabel sourceName="Others" />,
    children: [
      {
        id: 'data.ai',
        value: 'data.ai',
        name: 'data.ai',
        pagePoint: 'MarketReportsDataAi',
        text: <ReportSourceLabel sourceName="data.ai" />,
      },
      {
        id: 'NPD',
        value: 'NPD',
        name: 'npd',
        pagePoint: 'MarketReportsNPD',
        text: <ReportSourceLabel sourceName="NPD" />,
      },
      {
        id: 'Statista',
        value: 'Statista',
        name: 'statista',
        pagePoint: 'MarketReportsStatista',
        text: <ReportSourceLabel sourceName="Statista" />,
      },
      // Famitsu reports are temporarily unavailable; retain the tab definition for rollback.
      // {
      //   id: 'Famitsu',
      //   value: 'Famitsu',
      //   name: 'famitsu',
      //   pagePoint: 'MarketReportsFamitsu',
      //   text: <ReportSourceLabel sourceName="Famitsu" />,
      // },
      {
        id: 'Twitter',
        value: 'Twitter',
        name: 'twitter',
        pagePoint: 'MarketReportsTwitter',
        text: <ReportSourceLabel sourceName="Twitter" />,
      },
      {
        id: 'Fandom',
        value: 'Fandom',
        name: 'fandom',
        pagePoint: 'MarketReportsFandom',
        text: <ReportSourceLabel sourceName="Fandom" />,
      },
    ],
  },
];

export default function BusinessReportsMarket(props: any) {
  const { formatMessage } = useIntl();
  const {
    dataShow,
    reportSourceConfig,
    setActiveId,
    activeId,
    setSearchValue,
    searchValue,
    lang,
    debounceSearchChange,
    dataLoading,
    segmentValue,
    setSegmentValue,
    option,
    systemId,
    data,
    loading,
    loadingMore,
    noMore,
    lazyScrollRef,
    childrenData,
  } = useData(props, tabs);
  const [tabPointInfo, setTabPointInfo] = useState(tabs[0].pagePoint);
  // 是否包含其他数据源
  const [childrenDataSource, setChildrenDataSource] = useState(childrenData);

  const onActive = (tab: any) => {
    setActiveId(tab.id);
    if (tab?.children) {
      setChildrenDataSource(tab?.children);
    }
    if (!tab.value) {
      setChildrenDataSource([]);
    }
    history.replace(`/intelligence/reports/marketReports?tab=${tab?.name}`);
    if (dbiPageLogMes?.[tab?.pagePoint]) {
      setTabPointInfo(tab?.pagePoint);
      buriedPointPage(dbiPageLogMes?.[tab?.pagePoint]);
    }
  };
  const handleDownloadRun = async (id: string, name: string) => {
    if (!id) return;
    const res = await fetchReportExcel({ id, name });
    const blob = new Blob([res]);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = URL.createObjectURL(blob);
    // 保存下来的文件名
    a.download = name;
    document.body.appendChild(a);
    a.click();
    // 移除元素
    document.body.removeChild(a);
    return true;
  };
  const scrollBody = useRef(null);
  const [tabFixed, setTabFixed] = useState(false);

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const { scrollTop } = e.srcElement;
        // console.log(scrollTop);

        // 滚动判断距离 和定位条位置相关，开发调整
        if (scrollTop > 260) {
          setTabFixed(true);
        } else {
          setTabFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () => scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);

  return (
    <Content className="dbi-businessreports" ref={scrollBody}>
      <Content.Header className="dbi-header contentHead-normal" title={formatMessage({ id: 'dbi_market_report' })}>
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey={NEW_MARK_IDS_MAPPING_KEY}
            tabs={tabs}
            animated={false}
            activeId={['data.ai', 'NPD', 'Statista', 'Famitsu', 'Twitter'].includes(activeId) ? 'Others' : activeId}
            onActive={onActive}
          />
        </div>
      </Content.Header>
      <Content.Body full ref={lazyScrollRef} className="dbi-market-report-full">
        <MarqueeBanner />
        {/* 吸顶内容 */}
        <div className={`header-fixedtab ${tabFixed ? 'visible' : 'hide'}`}>
          <div className="header-tab">
            <Tabs
              ceiling
              newMarkIdsMappingKey={NEW_MARK_IDS_MAPPING_KEY}
              tabs={tabs}
              animated={false}
              activeId={activeId}
              onActive={onActive}
            />
          </div>
        </div>
        <Justify
          className="dbi-businessreports-justify"
          left={
            <>
              {childrenDataSource?.length > 0 && (
                <Segment
                  className="segment-light"
                  value={activeId}
                  onChange={(value) => {
                    const data = childrenDataSource.filter((item: any) => item.value === value);
                    if (data.length > 0) {
                      onActive(data[0]);
                    }
                  }}
                  options={childrenDataSource}
                />
              )}
              {dataShow?.length > 0 ? (
                <>
                  <Segment
                    className="segment-light"
                    value={segmentValue}
                    onChange={(value) => setSegmentValue(value)}
                    options={option}
                  />
                </>
              ) : null}
            </>
          }
          right={
            <SearchBox
              className="edit-search-box"
              value={searchValue}
              onChange={(word) => {
                if (word != searchValue) {
                  setSearchValue(word);
                  debounceSearchChange(word.trim());
                }
              }}
              placeholder={formatMessage({ id: 'dbi_reports_search_placeholder' })}
            />
          }
        />
        {loading ? (
          <div style={{ height: 'calc(100vh - 300px)', color: '#262832' }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : (
          // <div className="dbi-lazyreport-loading">
          //   <Icon size="l" type="loading" />
          //   &nbsp;&nbsp;&nbsp;{formatMessage({ id: 'dbi_reports_loading' })}
          // </div>
          <div>
            {data?.list?.map((item, index) => {
              const { display_source: displaySource } = resolveReportConfig(item, reportSourceConfig);
              return (
                <ReportCard
                  hasPDF
                  key={index}
                  data={languageItem(item, lang)}
                  displaySource={displaySource}
                  systemId={systemId}
                  type={'Market'}
                  isNew={!!moment(item?.time).isAfter(moment().subtract(1, 'month'))}
                  reportLangSegment={segmentValue}
                  tabPointInfo={tabPointInfo}
                  handleDownloadRun={handleDownloadRun}
                />
              );
            })}
          </div>
        )}
        {loadingMore && (
          <div className="dbi-lazyreport-loading dbi-lazyreport-end">
            <Icon size="l" type="loading" />
            &nbsp;&nbsp;&nbsp;
            {formatMessage({ id: 'dbi_reports_loading_more' })}
          </div>
        )}
        {dataShow?.length <= 0 && noMore && !loading && !dataLoading && (
          <div className="dbi-reportcard-nodata dbi-lazy-nodata">
            {formatMessage({ id: 'dbi_reports_no_data' })}
          </div>
        )}
      </Content.Body>
    </Content>
  );
}
